/**
 * Direct API axios instance for backend
 * Uses centralized API configuration from config.js
 *
 * IMPORTANT: baseURL already includes /api/v1
 * Example: baseURL = 'https://datahub.n2nai.io/api/v1'
 * Usage: axiosDirectApi.get('/cv/datasets') → https://datahub.n2nai.io/api/v1/cv/datasets
 */

import axios from 'axios';
import { API_BASE_URL } from '../config';
import { authManager } from './authManager';

// Base URL includes /api/v1 - do NOT add /api/v1 to paths
const directApiUrl = API_BASE_URL;

const axiosDirectApi = axios.create({
    baseURL: directApiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - Add authentication token
axiosDirectApi.interceptors.request.use(
    (config) => {
        const token = authManager.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor - Handle errors
axiosDirectApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            // Handle specific error codes
            switch (status) {
                case 401:
                    console.error('🔐 Unauthorized - Token may be invalid or expired');
                    authManager.clearTokens();
                    break;
                case 403:
                    console.error('🚫 Forbidden - Insufficient permissions');
                    break;
                case 404:
                    console.error('🔍 Not Found:', error.config?.url);
                    break;
                default:
                    console.error('Direct API Error:', error);
            }

            return Promise.reject(data || 'API Error');
        }

        console.error('Direct API Error:', error);
        return Promise.reject('Network Error');
    }
);

export default axiosDirectApi;
